import script from "./quick_add_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./quick_add_btn.vue?vue&type=script&setup=true&lang=js"

import "./quick_add_btn.vue?vue&type=style&index=0&id=3bae8557&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bae8557"]])

export default __exports__